import React from "react";

import './Menu.css';
import { Helmet } from "react-helmet";
import Button from "../../components/button/Button";
import { openReservation } from "../../utils/analytics";

export const Menu: React.FC = (): JSX.Element => {

    return (
        <>
            <Helmet>
                <title>Menu - Hallwylska Restaurang</title>
                <meta name="description" content="Explore the a la carte menu at Hallwylska Restaurang." />
                <link rel="canonical" href="https://hallwylskarestaurang.com/menu" />
                <meta property="og:title" content="Menu - Hallwylska Restaurang" />
                <meta property="og:description" content="Explore the a la carte menu at Hallwylska Restaurang." />
                <meta property="og:image" content="https://hallwylskarestaurang.com/img/menu/julbord.png" />
                <meta property="og:url" content="https://hallwylskarestaurang.com/menu" />
                <meta name="twitter:title" content="Menu - Hallwylska Restaurang" />
                <meta name="twitter:description" content="Explore the a la carte menu at Hallwylska Restaurang." />
                <meta name="twitter:image" content="https://hallwylskarestaurang.com/img/menu/julbord.png" />

            </Helmet>
            <section className="menu beige-bg pt-5 pb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-10 col-lg-8 offset-lg-2 offset-md-1 col-xl-6 offset-xl-3">
                            <h1 className="text-green text-center fly-left mb-4">Menus</h1>
                            
                            <div className="menu-buttons text-center mb-5">
                                <Button text='A La Carte'
                                    class_type="primary"
                                    onClick={() => window.open('/img/menu/HR_ALaCarte_A3_Updated_29July_2026.pdf', '_blank')} />
                                {/* <Button text='Weekly Lunch'
                                    class_type="primary"
                                    onClick={() => window.open('/img/menu/HR_Veckans_Lunch_V37_2026_A4.pdf', '_blank')} /> */}
                            </div>

                            <div className="text-center mb-4">
                                <img src="/img/HR_Hero_Table_General_2026.png"
                                    alt="Three tables and spilling wine on one of them with a tree in the background"
                                    className="menu__image fly-bottom"/>
                            </div>
                            
                            <div className="text-center mb-5">
                                <Button text='Make a Reservation'
                                    class_type="primary"
                                    onClick={() => openReservation('menu')} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}